import { Badge } from '@zarya/ui';
import { t } from '@app/i18n';
import { a2aTip, decisionTarget, type Decision } from './vocabulario';
import s from './Decisions.module.css';

/**
 * The «Destino» of a decision, in Decisões (T16) and in the last decisions of Visão geral (T3): one cell for both
 * screens, so the two never say different things about the same line. The rules live in `decisionTarget`.
 */
export function DecisionTargetCell({ decision }: { decision: Decision }) {
  const target = decisionTarget(decision);
  if (!target.a2a) return <>{target.texto}</>;
  return (
    <span className={s.alvoA2A}>
      <span>{target.texto}</span>
      <Badge tone="primary" tip={a2aTip()}>
        A2A
      </Badge>
      {target.external ? <Badge tone="neutral">{t('decisions.target.external')}</Badge> : null}
      {target.removed ? <span className={s.vazio}>{t('decisions.target.removed')}</span> : null}
    </span>
  );
}
